import type {RankingMetric} from '../../../../core/repositories/columnRepository';

export const COLUMNS_TOP = '/columns';

export const COLUMNS_LATEST = '/columns/latest';

export const COLUMNS_RANKING = (by: RankingMetric) =>
  `/columns/ranking?by=${by}`;

export const COLUMNS_BY_ALL_CATEGORIES = '/columns/category/all';

export const COLUMNS_BY_ROOT_CATEGORY = (categorySlug: string) =>
  `/columns/category/${categorySlug}`;

export const COLUMNS_BY_SUB_CATEGORY = (
  rootCategorySlug: string,
  subCategorySlug: string,
) => `/columns/category/${rootCategorySlug}/${subCategorySlug}`;

type ColumnsCompanyListParams = {
  industryId?: number;
};
export const COLUMNS_COMPANY_LIST = (params?: ColumnsCompanyListParams) => {
  const base = '/columns/companies';
  const query = new URLSearchParams();
  if (params?.industryId) {
    query.append('industryId', params.industryId.toString());
  }
  return query.toString() ? `${base}?${query.toString()}` : base;
};

export const extractColumnsCompanyListParams = (
  query: URLSearchParams,
): ColumnsCompanyListParams => {
  const _industryId = query.get('industryId');
  const industryId =
    _industryId && Number.isInteger(Number(_industryId))
      ? Number(_industryId)
      : undefined;
  return {industryId};
};

export const COLUMNS_BY_COMPANY = (companyId: number) =>
  `${COLUMNS_COMPANY_LIST()}/${companyId.toString()}`;

export const COLUMNS_BY_TAG = (name: string) => `/columns/tags/${name}`;

export const COLUMNS_SPONSORED = '/columns/sponsored';
